(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Mobile Menu Fix - Shrine Pro Enhancement
  class MobileMenuHandler {
    constructor() {
      this.init();
    }

    init() {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupMobileMenu());
      } else {
        this.setupMobileMenu();
      }
      
      // Force initial state setup after short delay
      setTimeout(() => {
        this.setupInitialAnimationState();
      }, 100);
    }

    setupInitialAnimationState() {
      // Setup for both header-drawer and menu-drawer
      const selectors = ['header-drawer', 'menu-drawer'];
      
      selectors.forEach(selector => {
        const menuItems = document.querySelectorAll(`${selector} .menu-drawer__menu > li`);
        const titleContainer = document.querySelector(`${selector} .menu-drawer__title-and-close-btn`);
        
        // Force initial hidden state for proper animation
        menuItems.forEach((item, index) => {
          item.style.transform = 'translateX(-20px)';
          item.style.opacity = '0';
          item.style.transition = `transform 0.3s ease ${(index + 1) * 0.05}s, opacity 0.3s ease ${(index + 1) * 0.05}s`;
        });
        
        if (titleContainer) {
          titleContainer.style.transform = 'translateY(-10px)';
          titleContainer.style.opacity = '0';
          titleContainer.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
        }
      });
      
      console.log('Initial animation state setup completed for both header-drawer and menu-drawer');
    }

    setupMobileMenu() {
      // Check for both header-drawer and menu-drawer
      const headerDrawer = document.querySelector('header-drawer');
      const menuDrawer = document.querySelector('menu-drawer');
      
      // Try header-drawer first, then menu-drawer
      const activeDrawer = headerDrawer || menuDrawer;
      const drawerType = headerDrawer ? 'header-drawer' : 'menu-drawer';
      
      const menuToggle = document.querySelector(`${drawerType} summary`);
      const menuDetails = document.querySelector(`${drawerType} details`);
      const closeButtons = document.querySelectorAll('.menu-drawer__close-menu-btn');
      
      console.log('Debug: Elements found:', {
        drawerType: drawerType,
        activeDrawer: !!activeDrawer,
        menuToggle: !!menuToggle,
        menuDetails: !!menuDetails,
        closeButtonsCount: closeButtons.length
      });
      
      if (!activeDrawer || !menuToggle || !menuDetails) {
        console.error('Mobile menu elements not found - missing required elements');
        return;
      }

      // Store references to avoid losing them
      this.activeDrawer = activeDrawer;
      this.drawerType = drawerType;
      this.menuToggle = menuToggle;
      this.menuDetails = menuDetails;
      this.closeButtons = closeButtons;

      // Add click handler with immediate feedback
      const handleToggleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Menu toggle clicked!');
        this.toggleMenu(this.menuDetails, this.menuToggle);
      };

      const handleCloseClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Close button clicked!');
        this.closeMenu(this.menuDetails, this.menuToggle);
      };
      
      // Add event listeners
      this.menuToggle.addEventListener('click', handleToggleClick);
      
      // Also try touchstart for better mobile support
      this.menuToggle.addEventListener('touchstart', (e) => {
        console.log('Menu toggle touched!');
      });

      this.closeButtons.forEach((button, index) => {
        console.log(`Adding listener to close button ${index}`);
        button.addEventListener('click', handleCloseClick);
      });

      // Handle escape key
      this.escapeHandler = (e) => {
        if (e.key === 'Escape' && this.menuDetails.hasAttribute('open')) {
          console.log('Escape key pressed - closing menu');
          this.closeMenu(this.menuDetails, this.menuToggle);
        }
      };
      
      document.addEventListener('keydown', this.escapeHandler);

      console.log('Mobile menu initialized successfully with debug logging');
    }



    toggleMenu(details, toggle) {
      const isOpen = details.hasAttribute('open');
      console.log(`Toggle menu called - currently ${isOpen ? 'open' : 'closed'}`);
      
      if (isOpen) {
        this.closeMenu(details, toggle);
      } else {
        this.openMenu(details, toggle);
      }
    }

    openMenu(details, toggle) {
      console.log('Opening menu...');
      
      // Force initial state before animation
      details.classList.remove('menu-opening');
      
      // Set attributes first
      details.setAttribute('open', '');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden-tablet');
      
      // Set header position
      const header = document.querySelector('.section-header');
      if (header) {
        const borderOffset = header.closest('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(header.getBoundingClientRect().bottom - borderOffset)}px`);
        header.classList.add('menu-open');
      }
      
      // Trigger animations with proper timing
      setTimeout(() => {
        requestAnimationFrame(() => {
          details.classList.add('menu-opening');
          
          // Animate menu items individually
          const menuItems = details.querySelectorAll('.menu-drawer__menu > li');
          const titleContainer = details.querySelector('.menu-drawer__title-and-close-btn');
          
          menuItems.forEach((item, index) => {
            setTimeout(() => {
              item.style.transform = 'translateX(0)';
              item.style.opacity = '1';
            }, (index + 1) * 50); // Stagger by 50ms
          });
          
          if (titleContainer) {
            setTimeout(() => {
              titleContainer.style.transform = 'translateY(0)';
              titleContainer.style.opacity = '1';
            }, 25);
          }
          
          console.log('Menu opening animation started with staggered items');
        });
      }, 10);
      
      console.log('Menu opened successfully');
    }

    closeMenu(details, toggle) {
      console.log('Closing menu...');
      
      // Reset menu items to hidden state first
      const menuItems = details.querySelectorAll('.menu-drawer__menu > li');
      const titleContainer = details.querySelector('.menu-drawer__title-and-close-btn');
      
      menuItems.forEach(item => {
        item.style.transform = 'translateX(-20px)';
        item.style.opacity = '0';
      });
      
      if (titleContainer) {
        titleContainer.style.transform = 'translateY(-10px)';
        titleContainer.style.opacity = '0';
      }
      
      // Remove animation class
      details.classList.remove('menu-opening');
      
      // Remove attributes
      details.removeAttribute('open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden-tablet');
      
      // Reset header
      const header = document.querySelector('.section-header');
      if (header) {
        header.classList.remove('menu-open');
      }
      
      // Close submenus - both header-drawer and menu-drawer
      document.querySelectorAll('header-drawer details[open], menu-drawer details[open]').forEach(submenu => {
        if (submenu !== details) {
          submenu.removeAttribute('open');
          submenu.classList.remove('menu-opening');
        }
      });
      
      console.log('Menu closed successfully with reset animation state');
    }
  }

  // Initialize mobile menu handler
  new MobileMenuHandler();

  // Create a separate MenuDrawer handler for standalone menu-drawer elements
  class MenuDrawerHandler extends MobileMenuHandler {
    constructor() {
      super();
      this.isStandalone = true;
    }

    setupMobileMenu() {
      // Only look for standalone menu-drawer elements
      const menuDrawer = document.querySelector('menu-drawer');
      if (!menuDrawer || document.querySelector('header-drawer')) {
        return; // Skip if header-drawer exists (it takes priority)
      }
      
      const menuToggle = document.querySelector('menu-drawer summary');
      const menuDetails = document.querySelector('menu-drawer details');
      const closeButtons = document.querySelectorAll('menu-drawer .menu-drawer__close-menu-btn');
      
      console.log('Debug: Standalone menu-drawer found:', {
        menuDrawer: !!menuDrawer,
        menuToggle: !!menuToggle,
        menuDetails: !!menuDetails,
        closeButtonsCount: closeButtons.length
      });
      
      if (!menuToggle || !menuDetails) {
        console.error('Standalone menu-drawer elements not found');
        return;
      }

      // Store references
      this.activeDrawer = menuDrawer;
      this.drawerType = 'menu-drawer';
      this.menuToggle = menuToggle;
      this.menuDetails = menuDetails;
      this.closeButtons = closeButtons;

      // Same event handlers as parent class
      const handleToggleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Standalone menu-drawer toggle clicked!');
        this.toggleMenu(this.menuDetails, this.menuToggle);
      };

      const handleCloseClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Standalone menu-drawer close clicked!');
        this.closeMenu(this.menuDetails, this.menuToggle);
      };
      
      // Add event listeners
      this.menuToggle.addEventListener('click', handleToggleClick);
      
      this.closeButtons.forEach((button, index) => {
        console.log(`Adding listener to standalone menu-drawer close button ${index}`);
        button.addEventListener('click', handleCloseClick);
      });

      // Handle escape key
      this.escapeHandler = (e) => {
        if (e.key === 'Escape' && this.menuDetails.hasAttribute('open')) {
          console.log('Escape key pressed - closing standalone menu-drawer');
          this.closeMenu(this.menuDetails, this.menuToggle);
        }
      };
      
      document.addEventListener('keydown', this.escapeHandler);

      console.log('Standalone menu-drawer initialized successfully');
    }
  }

  // Initialize standalone menu-drawer handler
  setTimeout(() => {
    new MenuDrawerHandler();
  }, 200);

  // Simple validation to ensure everything is working
  setTimeout(() => {
    console.log('Validating mobile menu setup...');
    const headerHandler = document.querySelector('header-drawer');
    const menuHandler = document.querySelector('menu-drawer');
    if (headerHandler) {
      console.log('Header-drawer mobile menu is ready and functional');
    }
    if (menuHandler && !headerHandler) {
      console.log('Standalone menu-drawer is ready and functional');
    }
  }, 500);


  } catch(e) { console.error(e); }
})();
})();
